<template>
  <div class="container-fluid">
    <loading v-if="renderLoading"></loading>
    <div class="row">
      <div class="col-12">
        <net-pa-card>
          <template v-slot:header>
            <h4>استعلام و ثبت چک</h4>
          </template>
          <template slot="content">
            <div class="row">
              <div class="col-12 p-md-3">
                <div class="w-100 border border-warning rounded px-4 py-2">
                  <p class="m-x-4 m-y-2">
                    این سامانه تنها قادر به بررسی و استعلام چک هایی است که در وجه <i class="font-weight-bold">[{{ $session.get('NameSandogh') }}] </i>صادر شده اند.
                  </p>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <small>شناسه صیادی چک</small>
                <input v-model="Data.sayadId" @keypress="$ValidNumber($event, 16)" type="text" dir="ltr" class="form-control text-left" />
              </div>

              <div class="col-4">
                <button @click="Estelam" class="btn btn-success w-100 mt-4">استعلام</button>
              </div>
            </div>
            <div v-if="ChequeData != null" class="row mt-3 border rounded p-3">
              <div class="col-12">
                <h3 class="text-primary">مشخصات چک</h3>
                <hr />
              </div>
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-4 font-weight-bold f-big">وضعیت چک:</div>
                  <div class="col-8 f-big">
                    {{ ChequeData.chequeStatus }}
                  </div>
                  <hr />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-4 font-weight-bold f-big">شناسه صیاد:</div>
                  <div class="col-8 f-big">
                    {{ ChequeData.sayadId }}
                  </div>
                  <hr />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-4 font-weight-bold f-big">سری/سریال چک:</div>
                  <div class="col-8 f-big">
                    {{ ChequeData.serialNo + '  ــــ  ' + ChequeData.seriesNo }}
                  </div>
                  <hr />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-4 font-weight-bold f-big">مبلغ چک:</div>
                  <div class="col-8 f-big">{{ $Comma3ragham(ChequeData.amount) + ' ' + $GetVahedPool() }} }}</div>
                  <hr />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-4 font-weight-bold f-big">تاریخ چک:</div>
                  <div class="col-8 f-big">
                    {{ ChequeData.dueDate }}
                  </div>
                  <hr />
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-2 font-weight-bold f-big">شناسه شبای چک:</div>
                  <div class="col-10 f-big">
                    {{ ChequeData.fromIban }}
                  </div>
                  <hr />
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-2 font-weight-bold f-big">بابت:</div>
                  <div class="col-10 f-big">
                    {{ ChequeData.description }}
                  </div>
                  <hr />
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-2 font-weight-bold f-big">نوع چک:</div>
                  <div class="col-10">
                    {{ ChequeData.chequeType }}
                  </div>
                  <hr />
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-2 font-weight-bold f-big">گیرنده:</div>
                  <div class="col-10 f-big">
                    {{ ChequeData.holders[0].name + ' - ' + ChequeData.holders[0].idCode + ' - ' + ChequeData.holders[0].idTypes }}
                  </div>
                  <hr />
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <hr />
                    <h3 class="text-primary">ثبت چک در حساب</h3>
                    <h5>برای ثبت چک در حساب یکی از حسابهای خود را انتخاب کنید</h5>
                  </div>
                  <div class="col-md-4 col-12">
                    <small>انتخاب بانک چک</small>
                    <SelectCombo @result="getSelectedBank" :readFromAction="'SelAzaHesab/GetBanks'"></SelectCombo>
                  </div>
                  <div class="col-md-4 col-12">
                    <small>نام شعبه بانک</small>
                    <input type="text" v-model="DataSarHesab.ShobeChk" placeholder="نام شعبه" class="form-control" />
                  </div>
                  <div class="col-md-4 col-12"></div>
                  <div class="col-md-4 col-12">
                    <small>نام صاحب چک (صادر کننده)</small>
                    <input type="text" v-model="DataSarHesab.SahebCheck" placeholder="نام صاحب چک " class="form-control" />
                  </div>
                  <div class="col-md-4 col-12">
                    <small>کد ملی صاحب چک (صادر کننده)</small>
                    <input type="text" v-model="DataSarHesab.CodeMeliSahebCheck" placeholder="کد ملی صاحب چک " class="form-control" />
                  </div>
                  <div class="col-md-4 col-12"></div>
                  <div class="col-md-4 col-12">
                    <small>انتخاب حساب</small>
                    <select name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer text-center" v-model="DataSarHesab.WwwtblTaahodatId" style="font-size: 15px !important">
                      <option disabled value="-1" style="font-size: 15px !important">-- یکی از حساب های خود را انتخاب کنید --</option>
                      <option v-for="item in this.ListTaahodat" :key="item.id" :value="item.id" style="font-size: 15px !important">
                        <span>{{ item.vcodeDesNo }} </span><span>{{ item.nameFamily }} </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 col-12"></div>
                  <div class="col-md-4 col-12">
                    <button class="btn btn-info w-100 mt-4" @click="AddChequeSarHesab">ثبت چک</button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '../Tools/NetPa/Loading.vue'
import SelectCombo from '@/components/Tools/SelectCombo.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
export default {
  components: { Loading, NetPaCard, SelectCombo },
  data() {
    return {
      renderLoading: false,
      Data: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BankId: 'BSI',
          ClientId: 'NUFd137XKt',
          ClientSecret: 'i8UoHX9IWd',
        },
        bank: 'BSI',
        sayadId: '',
        idCode: '',
        idTypes: 'legalCustomer',
      },
      Token: '',
      Hazine: 0,
      ChequeData: null,
      ListTaahodat: [],
      DataSarHesab: {
        Id: 11,
        BnpCashDbtblChkSareHesabId: null,
        WwwtblTaahodatId: null,
        Wwwtblshobeid: null,
        SerialChk: null,
        ShobeChk: null,
        ShHesabChk: null,
        TblBankId: null,
        TblComboIdVaziyatChk8: null,
        MablaghChk: null,
        TarixChk: null,
        TarixDaryaft: null,
        CodeShobe: null,
        City: null,
        Moshaxasat: null,
        SahebCheck: null,
        IsBargashtShode: null,
        DateTimeInsert: null,
        IsApproved: null,
        Seri: null,
        CodeMeliSahebCheck: '',
      },
      Bank: null,
    }
  },
  methods: {
    GetShenaseMeli() {
      this.$PostData({ Action: 'Tanzim`at', ArryfildValue: null, Method: 'GET' }).then((result) => {
        this.Data.idCode = result[0].shenaseMeli.trim()
      })
    },
    Estelam() {
      this.renderLoading = true
      // this.$mySweetDefault('خطا', result.message, 'error', 2000)
      this.$PostData_netpatoken({ action: 'EstelamCheq', arryfildValue: this.Data, method: 'POST' })
        .then((result) => {
          if (result.errorCode) {
            this.$mySweetDefault('خطا', result.message, 'error', 2000)
          } else {
            result.respObject.dueDate = result.respObject.dueDate.substring(0, 4) + '/' + result.respObject.dueDate.substring(4, 6) + '/' + result.respObject.dueDate.substring(6, 8)
            if (result.transactionState && result.transactionState == 'SUCCESS') {
              this.ChequeData = result.respObject

              switch (this.ChequeData.chequeStatus) {
                case 'registeredReceiverApproval':
                  this.ChequeData.chequeStatus = 'ثبت شده با تأیید گیرنده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4114
                  break

                case 'criticized':
                  this.ChequeData.chequeStatus = 'نقد شده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4022
                  break

                case 'voided':
                  this.ChequeData.chequeStatus = 'باطل شده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4102
                  break

                case 'returned':
                  this.ChequeData.chequeStatus = 'برگشت خورده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4024
                  break

                case 'partReturned':
                  this.ChequeData.chequeStatus = 'بخشی برگشت خورده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4024
                  break

                case 'waitingSignatureGuarantor':
                  this.ChequeData.chequeStatus = 'در انتظار ضامن'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 43115
                  break

                case 'waitingRecipientConfirmWithdrawalCheck':
                  this.ChequeData.chequeStatus = 'در انتظار تأیید گیرنده در کشیدن چک'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 43115
                  break

                case 'waitingRecipientConfirmTransferCheck':
                  this.ChequeData.chequeStatus = 'در انتظار تأیید گیرنده در انتقال چک'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 43115
                  break

                default:
                  break
              }
              switch (this.ChequeData.chequeType) {
                case 'normal':
                  this.ChequeData.chequeType = 'چک عادی'
                  break

                case 'bank':
                  this.ChequeData.chequeType = ' چک بانکی'
                  break

                case 'encrypted':
                  this.ChequeData.chequeType = 'چک رمزدار'
                  break

                default:
                  break
              }
              switch (this.ChequeData.chequeMedia) {
                case 'paperCheck':
                  this.ChequeData.chequeMedia = 'چک کاغذی'
                  break

                case 'digitalCheck':
                  this.ChequeData.chequeMedia = 'چک دیجیتال'
                  break

                default:
                  break
              }
              if (this.ChequeData.holders[0].idTypes == 'realCustomer') this.ChequeData.holders[0].idTypes = 'حقیقی ایرانی'
              else if (this.ChequeData.holders[0].idTypes == 'legalCustomer') this.ChequeData.holders[0].idTypes = 'حقوقی ایرانی'
              else if (this.ChequeData.holders[0].idTypes == 'realAliens') this.ChequeData.holders[0].idTypes = 'اتباع حقیقی'
              else if (this.ChequeData.holders[0].idTypes == 'legalAliens') this.ChequeData.holders[0].idTypes = 'اتباع بیگانه'
            }
          }
        })
        .finally(() => {
          this.renderLoading = false
        })
    },

    GetListTaahodat() {
      const formData = new FormData()
      let info
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId)
      var DataAxios_cmbTaahodat = { ArryfildValue: formData, Method: 'Post', Action: 'ListTaahodat', Token: this.$session.get('TokenNetPa') }
      this.$PostFormData(DataAxios_cmbTaahodat).then((data) => {
        this.ListTaahodat = data.filter((x) => x.tblSarfaslTypeId != 6)
      })
    },
    AddChequeSarHesab() {
      if (this.DataSarHesab.WwwtblTaahodatId == null || this.DataSarHesab.WwwtblTaahodatId == '') {
        this.$mySweetDefault('خطا!', 'لطفا نام یکی از حساب های خود در '+this.$session.get('IsTaavoniEtebar')==true?'تعاونی اعتبار':'صندوق'+'  را انتخاب کنید', 'error', 2000)
      } else if (this.Bank == null || this.Bank == '') {
        this.$mySweetDefault('خطا!', 'لطفا بانک صادر کننده چک را انتخاب کنید', 'error', 2000)
      } else {
        this.DataSarHesab.Id = 11
        this.DataSarHesab.Wwwtblshobeid = this.$session.get('UserInfoNetPa').wwwtblShobeId
        this.DataSarHesab.SerialChk = this.ChequeData.serialNo
        this.DataSarHesab.Seri = this.ChequeData.seriesNo
        this.DataSarHesab.ShHesabChk = this.ChequeData.fromIban
        this.DataSarHesab.MablaghChk = this.ChequeData.amount
        this.DataSarHesab.SayadNo = this.ChequeData.sayadId
        this.DataSarHesab.TarixChk = this.ChequeData.dueDate
        this.DataSarHesab.TarixDaryaft = this.$GetJalaliDateTime().substring(0, 10)
        this.DataSarHesab.CodeShobe = this.ChequeData.branchCode
        this.DataSarHesab.Moshaxasat = this.$session.get('UserInfoNetPa').ozvFamily + ' ' + this.$session.get('UserInfoNetPa').ozvName
        this.DataSarHesab.DateTimeInsert = this.$GetJalaliDateTime()
        this.DataSarHesab.IsApproved = false
        this.DataSarHesab.IsBargashtShode = false
        this.DataSarHesab.TblBankId = this.Bank

        var dataAxiosAdd = { action: 'ChkSareHesabadd', method: 'POST', arryfildValue: this.DataSarHesab }
        this.$PostData_netpatoken(dataAxiosAdd).then((result) => {
          this.$mySweetDefault(result.title, result.msg, result.icon, 2000)
        })
      }
    },
    getSelectedBank(data) {
      this.Bank = data.bnpcashDbId
    },
  },
  created() {
    this.GetShenaseMeli()

    this.GetListTaahodat()
  },
}
</script>
<style scoped>
.f-big {
  font-size: 15px !important;
}
</style>
